module.exports = __webpack_public_path__ + "img/case-szbwg.ff33fb13.png";